import { Flex, Typography } from '@aloft/toolkit-sui';

type UploadDocumentsFieldProps = React.PropsWithChildren<{
  id: string;
  label: string;
  required?: boolean;
}>;

export function UploadDocumentsField(props: UploadDocumentsFieldProps) {
  // HACK: This steals the required asterisk from `<SimpleFormWrapper>`.
  // Ideally, we'd add `<FileUploader>` to SUI and have it accept all the
  // form control props that our other `<Simple*>` inputs accept.

  return (
    <Flex flexDirection="column" flexBasis="300px" height="180px">
      <label htmlFor={props.id} className="simple-field-label">
        <Typography variant="label">{props.label}</Typography>
        {props.required && <span className="simple-field-required">*</span>}
      </label>
      {props.children}
    </Flex>
  );
}
